export default function calcDayDiff(date: Date | string): number | string {
  if (typeof date === "string") {
    return "---";
  }
  const ONE_DAY = 1000 * 60 * 60 * 24; // Millisekunden in einem Tag
  const now = new Date(); // aktuelles Datum und Uhrzeit
  const timeDiff = now.getTime() - date.getTime(); // Zeitdifferenz in Millisekunden
  const daysDiff = Math.floor(timeDiff / ONE_DAY); // Zeitdifferenz in Tagen
  return daysDiff;
}
